/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

import { defineAsyncComponent } from "vue";

// Plugins
import { loadFonts } from "./webfontloader";
import vuetify from "./vuetify";
import pinia from "../store";
import router from "../router";
import VueCountdown from "@chenfengyuan/vue-countdown";
import { MotionPlugin } from "@vueuse/motion";
import { VueFire, VueFireAuth } from "vuefire";
import { firebaseApp } from "./firebase";

const loadVue3Lottie = () =>
  import("vue3-lottie").then(
    (module) => module.Vue3Lottie || module.default,
  );

const loadVueParticles = () =>
  import("vue3-particles").then(
    (module) => module.ParticlesComponent || module.default,
  );

export function registerPlugins(app) {
  loadFonts();
  app.use(vuetify);
  app.use(VueFire, {
    firebaseApp,
    modules: [VueFireAuth()],
  });
  app.use(pinia);
  app.use(router);
  app.use(MotionPlugin);

  app.component(
    "Vue3Lottie",
    defineAsyncComponent({
      loader: loadVue3Lottie,
    }),
  );
  app.component(
    "vue-particles",
    defineAsyncComponent({
      loader: loadVueParticles,
    }),
  );
  app.component(
    "Particles",
    defineAsyncComponent({
      loader: loadVueParticles,
    }),
  );
  app.component(VueCountdown.name, VueCountdown);
}
